const state = { };

const getters = { };

const mutations = { };

const actions = {
    async incrementPublicVisits({ rootGetters }) {
        const establishmentId = rootGetters['establishment/getEstablishmentId'];
        const gapFlag = !!rootGetters['appointments/getGapFlag'];
        await this._vm.$api.stats.incrementPublicVisitsForEstablishment(establishmentId, gapFlag);
    },

    async insertKPIStatistic({ rootGetters }, payload) {
        const establishmentId = rootGetters['establishment/getEstablishmentId'];
        const gapFlag = !!rootGetters['appointments/getGapFlag'];
        const [service, place, firstAvailabilityDate] = payload;

        await this._vm.$api.stats.insertKPIStatisticForEstablishment(
            establishmentId, service, place, firstAvailabilityDate, gapFlag
        );
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
